
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.667 5.833H3.334c-.92 0-1.667.747-1.667 1.667v8.333c0 .92.746 1.667 1.667 1.667h13.333c.92 0 1.667-.746 1.667-1.667V7.5c0-.92-.747-1.667-1.667-1.667zM13.334 5.833V4.167A1.667 1.667 0 0011.667 2.5H8.334a1.667 1.667 0 00-1.667 1.667v1.666","stroke":"#667080","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    